<template>
  <div class="d-flex align-center justify-space-around">
    <select-box
      v-model="selectedHour"
      :items="hours"
      label="Hour"
      class="mx-2"
      not-attached
      :required="required"
      @change="$nextTick(emitTime)"
    ></select-box>
    <select-box
      v-model="selectedMinute"
      :items="minutes"
      label="Minute"
      class="mx-2"
      not-attached
      :required="required"
      @change="$nextTick(emitTime)"
    ></select-box>
    <select-box
      v-model="selectedFormat"
      :items="formats"
      label="Period"
      class="mx-2"
      not-attached
      :required="required"
      @change="$nextTick(emitTime)"
    ></select-box>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hours: {
      type: Array,
      default: () => [],
    },
    minutes: {
      type: Array,
      default: () => [],
    },
    defaultTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedHour: null,
      selectedMinute: null,
      selectedFormat: null,
      formats: ['AM', 'PM'],
      defaultSet: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) this.defaultSet = true

        if (!val) {
          if (this.defaultTime && !this.defaultSet) {
            this.setDefaultToCurrentTime()
            this.defaultSet = true
          }

          return
        }

        this.loadTimeFromValue(val)
      },
      immediate: true,
    },
  },
  methods: {
    loadTimeFromValue(val) {
      if (!val) return

      const [hStr, m] = val.split(':')
      const hour = parseInt(hStr, 10)

      const format = hour >= 12 ? 'PM' : 'AM'
      const hour12 = hour % 12 === 0 ? 12 : hour % 12

      this.selectedHour = String(hour12).padStart(2, '0')
      this.selectedMinute = m
      this.selectedFormat = format
    },
    convertTo24Hour(hour12, format) {
      let hour = parseInt(hour12, 10)

      if (format === 'PM' && hour !== 12) hour += 12
      if (format === 'AM' && hour === 12) hour = 0

      return String(hour).padStart(2, '0')
    },
    isValidTime() {
      return this.selectedHour && this.selectedMinute && this.selectedFormat
    },
    emitTime() {
      if (!this.isValidTime()) {
        this.$emit('input', null)

        return
      }

      const hour24 = this.convertTo24Hour(this.selectedHour, this.selectedFormat)
      const time = `${hour24}:${this.selectedMinute}`
      this.$emit('input', time)
    },
    async setDefaultToCurrentTime() {
      const now = new Date()
      const hour = now.getHours()
      const minute = String(now.getMinutes()).padStart(2, '0')
      const format = hour >= 12 ? 'PM' : 'AM'
      const hour12 = hour % 12 === 0 ? 12 : hour % 12

      this.selectedHour = String(hour12).padStart(2, '0')
      this.selectedMinute = minute
      this.selectedFormat = format

      await this.$nextTick(this.emitTime())
    },
  },
}
</script>

<style scoped>
.gap-4 {
  gap: 16px;
}
</style>
